import { Controller } from '@hotwired/stimulus'

export default class NoteGateController extends Controller<HTMLElement> {
  static targets = ['note', 'button']

  declare readonly noteTarget: HTMLTextAreaElement
  declare readonly buttonTarget: HTMLButtonElement

  refresh (): void {
    this.buttonTarget.disabled = this.noteTarget.value.trim() === ''
  }
}
